module.exports = __webpack_public_path__ + "img/Panduan.1bd8dccc.svg";